module.exports = __webpack_public_path__ + "static/media/spinner-logo.60edd1e2.png";